import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import {
  IContractEnrollmentRequest,
  IContractEnrollmentResponse,
  IBaseCoverageRequest,
  IBaseCoverageResponse
} from '../../interfaces/IEnrollment';
import { ENROLLMENT, BASE_COVERAGE, getApiUrlForParams } from '../../utils/api.util';
import { DataService } from '../data/data.service';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentService {
  constructor(private http: HttpService, private data: DataService) { }

  /**
   * Triggers a POST call to enroll a contract with the given payload.
   * 
   * @param request - The Contract Enrollment Request payload
   * @returns Observable resolving to the Contract Enrollment Response payload
   */
  enrollContract(request: IContractEnrollmentRequest): Observable<IContractEnrollmentResponse> {
    // no param needed for this api 
    // but the method expects param 
    // so passing that
    const url = getApiUrlForParams(ENROLLMENT, { contractNumber: request.contractNumber })
    const vivrAccessToken = this.data.vivrAccessToken$.getValue();
    let options = undefined;

    if (this.data.isVivr$.getValue() && vivrAccessToken) {
      let headers: { [key: string]: string } = this.http.getHeaders(vivrAccessToken);
      options = { headers };
    }

    return this.http.post<IContractEnrollmentResponse>(url, request, options);
  }

  /**
   * Triggers a POST call to fetch base coverage information for a product and ZIP code.
   * 
   * @param request - The Base Coverage Request payload
   * @returns Observable resolving to the Base Coverage Response payload
   */
  getBaseCoverage(request: IBaseCoverageRequest): Observable<IBaseCoverageResponse> {
    // no param needed for this api 
    // but the method expects param 
    // so passing that
    const url = getApiUrlForParams(BASE_COVERAGE, { productId: request.productId })
    const vivrAccessToken = this.data.vivrAccessToken$.getValue();
    let options = undefined;

    if (this.data.isVivr$.getValue() && vivrAccessToken) {
      let headers: { [key: string]: string } = this.http.getHeaders(vivrAccessToken);
      options = { headers };
    }
    return this.http.post<IBaseCoverageResponse>(url, request, options);
  }
}
